
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@babel/polyfill"
import Vue from "vue";
import axios from "axios"
import ElementUI from "element-ui";
import Thaii from "thaii"
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
// import "./assets/css/index.css";
import Viewer from "v-viewer"
import "viewerjs/dist/viewer.css"
import router from "./router/routers";
import common from "./utils/common/common";
import store from "./store/store";
import '@/utils/filters'

import interfaceListUrl from "./utils/interface-list/interface-list";
import configServer from "./utils/config-server/config-server";
import configData from "./utils/config-data/config-data";
import storage from "./utils/storage/storage";
import moment from "moment";
import commonComponent from "./components/common-components";
import exportExcel from "./utils/common/export-xlsx.js"
import("@/utils/rem")

import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '228a2d3b4f2c142386aa8b6ad900df52',
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.MouseTool',
    'AMap.MoveAnimation',
    'AMap.Geocoder'
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4',
});


Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})
moment.locale("fr", {
  calendar: {
    sameDay: "[今天]LT",
    nextDay: "[明天]LT",
    nextWeek: "[下]ddddLT",
    lastDay: "[昨天]LT",
    lastWeek: "[上]ddddLT",
    sameElse: "L"
  },
  relativeTime: {
    future: "%s内",
    past: "%s",
    s: "0分钟",
    ss: "0分钟",
    m: "1分钟",
    mm: "%d分钟",
    h: "1小时",
    hh: "%d小时",
    d: "1天",
    dd: "%d天",
    M: "1个月",
    MM: "%d个月",
    y: "1年",
    yy: "%d年"
  }
})

Vue.prototype.$axios = axios;
Vue.use(ElementUI);
Vue.use(Thaii)
Vue.prototype.$common = common;
Vue.prototype.$interfaceList = interfaceListUrl;
Vue.prototype.$configServer = configServer;
Vue.prototype.$configData = configData;
Vue.prototype.$storage = storage;
Vue.prototype.$moment = moment;
Vue.use(commonComponent);

Vue.filter('thousandSeparator', function (value) {
  if (!value) return '0';
  value = value.toString();
  return value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
});

Vue.prototype.$export = exportExcel

Vue.prototype.$formatTime = function formatTime(seconds) {
  if (isNaN(seconds) || seconds < 0) {
    return "";
  }

  const days = Math.floor(seconds / (24 * 3600));
  const hours = Math.floor((seconds % (24 * 3600)) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  const timeArray = [];

  if (days > 0) {
    timeArray.push(`${days}天`);
  }

  if (hours > 0) {
    timeArray.push(`${hours}小时`);
  }

  if (minutes > 0) {
    timeArray.push(`${minutes}分钟`);
  }

  if (remainingSeconds > 0) {
    timeArray.push(`${remainingSeconds}秒`);
  }

  return timeArray.join(" ");
}

Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.mixin({
  methods: {
    getLinkUrl(orderNo, orderType = "") {
      this.$axios.get(this.$configServer.API_URL + "portal/common/fincialToOrderDetail", {
        params: { orderNo, orderType }
      }).then(res => {
        if (res.result) {
          parent.document.getElementById("innerIframe").src = res.result
        } else {
          this.$common.message({
            message: "该单号暂不支持跳转",
            type: "error",
            duration: 1500
          })
        }
      });
    }
  }
})


new Vue({
  el: "#app",
  router,
  store,
  render: function (createElement) {
    if ("-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style) {
      window.addEventListener("hashchange", () => {
        var currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }, false)
    } else {
    }
    return createElement(App);
  },
  components: { App },
  template: "<App/>"
})



// WEBPACK FOOTER //
// ./src/main.js